module.exports = {
  appName: '製造実行管理システム',
  message: {
    title: 'システムのヒント',
    error_factory_code_not_input: '工場のコードを入力してください',
    error_employee_code_not_input: '従業員のコードを入力してください',
    error_custom_code_not_input: '顧客コードを入力してください',
    error_verify_code_not_input: '検証コードを記入してください',
    error_login_password_not_input: 'ログインパスワードを入力してください',
    error_device_code_not_input: 'デバイスコードを入力してください',
    error_info: 'エラーメッセージ',
    error_ajax: 'データは間違いを求めて、後の再試験を更新してください！',
    error_not_login: 'ログインしてからやり直してください!',
    error_permission_validate: 'あなたは現在の操作を実行する権限がありません!',
    error_can_empty: '今の項目は空けてはいけない！',
    error_opera_retry: '操作に失敗し、再び試みて下さい！',
    timeout: '接続オーバー、やり直してください！',
    error_sysdate_can_not_execute_current_opera: 'システムデータ、この操作を実行できません！',
    error_can_not_delete_because_used: '現在のデータは使用中で、削除できません！',
    error_code_same_pleas_change: 'コード重複、確認してください！',
    has_children_can_not_delete: '存在子は、削除できません！',
    please_input_required_items: '必須アイテムを入力してください!',
    please_select_row_to_opera: '操作するデータを選択してください',
    please_check_row_to_opera: '操作するデータをチェックしてください',
    can_not_delete_system_data: 'システムデータ、削除できません',
    error_404: 'あなたが訪問したページは存在しません',
    error_403: 'あなたの現在のページアクセス権限がない',
    error_go_back: '帰って前のページ',
    error_go_login: '戻る登録',
    Employee_Code_does_not_exist: '社員コード【%1】存在しません',
    Device_code_does_not_exist: 'デバイスコード【%1】存在しません',
    Craft_code_does_not_exist: '工艺编码【%1】不存在',
    please_select_part_to_opera: '操作する部品を選択してください',
    please_select_process_to_opera: '操作を選択してください',
    old_password_error: '元のパスワードが間違っています',
    confirm_delete_data: '選択したデータを削除しますか？',
    error_param_validate: 'パラメータ検証に失敗しました。不正アクセスを確認してください。'
  },
  login: {
    login: 'ログイン',
    remember: 'パスワードを覚えてください',
    verify_code: '認証コード'
  },
  nav: {
    produce_order: '生産工書',
    project_manage: 'プロジェクト管理',
    process_manage: '工程管理',
    progress_query: '進捗調査',
    report: '現場新聞',
    quality_manage: '品質管理',
    quality_determine: "品質判定",
    quality_penalty: "品質ペナルティ",
    quality_recall: "品質リコール",
    system_setting: 'システム設定',
    modify_password: 'パスワードを修正する',
    personal_center: '個人の中心',
    exit_system: 'ログインを終了する',
    plan: '日の計画管理',
    forms: 'レポート',
    basic_data: {
      title: '基礎資料',
      factory_setting: '工場の設定',
      department_manage: '部門管理',
      role_manage: 'キャラクター管理',
      employee_manage: '従業員の管理',
      device_manage: 'デバイス管理',
      operation_manage: '工芸管理',
      production_line_manage: '生産ラインの管理',
      cost_type_manage: '費用の種類',
      shelf_manage: '棚管理',
      work_group_manage: '作業グループ管理',
      software_download: 'ダウンロード'
    },
    classify_setting: {
      title: '分類設定',
      product_type: '製品のタイプ',
      order_type: '注文タイプ',
      part_classify: '部品の分類',
      error_classify: 'エラーの分類',
      project_classify: 'プロジェクト分類'
    },
    job_deployment: '作業配置',
    standard_process_library: '標準工芸庫',
    custom_column: 'カスタム列',
    log_manage: 'ログ管理',
    approval_process: '審査の流れ',
    class_table_setting: 'クラス表の設定',
    holiday_setting: '休日の設定',
    offline_file_setting: 'ライン下のファイル設定',
    standard_procedure_setting: '指導書の設定',
    project_master_plan: '主な計画',
    project_master_plan_template_setting: 'マスタープランテンプレート設定',
    customer_form: 'カスタムフォーム'
  },
  common: {
    opera: 'する',
    open: '開く',
    upload: 'アップ',
    file: 'ファイル',
    setting: '設定',
    factoryCode: '工場のコーディング',
    employeeCode: '従業員のコーディング',
    LoginPassword: 'パスワードを登録する',
    add_user: '人を追加する',
    add_time: '時間を追加する',
    update_user: '更新人',
    update_time: '更新時間',
    add: '追加',
    save: '保存する',
    saveAndAdd: '保存して追加します',
    reset: '書き直す',
    cancel: '取り消す',
    delete: '削除',
    edit: '編集する',
    query: 'クエリ',
    img_is_not_upload: '図面はまだ送っていませんでした',
    confirm: '確認する',
    filter: '濾過する',
    please_input_filter_content: '選択した内容を入力してください',
    default_value_setting: 'デフォルト値設定',
    name: '名称',
    remark: '備考',
    display: '表示する',
    hide: '隠して',
    move: '移動する',
    copy: 'コピーする',
    see: 'チェックする',
    split: 'セグメンテーション',
    more: 'もっと',
    approved: 'すでに審査した',
    approval_status: '承認状態',
    approval_sponsor: '決裁の発起人',
    approver: '承認者',
    approval_approval: '承認を通過する',
    approval_return: '承認が戻ってくる',
    ongoing: '進行中',
    opera_type: '操作タイプ',
    code: 'コード',
    capacity: '産能',
    select_department: '選択部門',
    select_resources: 'リソースを選択',
    craft: '工芸',
    production_line: '生産線',
    status: '状態',
    today: '今日',
    import_start_row: '最初の行',
    select_craft: '選択プロセス',
    amount: '金額',
    paste: '貼り付け',
    close_copy_model: 'コピーモードを終了',
    reset_cache: 'ブラウザのキャッシュをリセット'
  },
  password: {
    original_password: 'パスワード',
    new_password: '新しいパスワード',
    confirm_password: 'パスワードを確認する',
    error_please_input_original_password: 'オリジナルのパスワードを入力してください',
    error_please_input_new_password: '新しいパスワードを入力してください',
    error_please_input_confirm_password: '確認パスワードを入力してください',
    error_please_input_password_not_same: '2回の入力のパスワードが一致しません',
    default_password_tip: '従業員の暗黙のパスワード: 123456',
    reset_password: 'パスワードをリセットする',
    password_is_reset: 'パスワードがリセットされ、新しいパスワードは: 123456'
  },
  status: {
    scrap: '廃絶する',
    normal: '正常である',
    repair: '修理する'
  },
  basic_data: {
    nav_width: '200px',
    role_manage: {
      role_name: 'キャラクター名',
      used_count: '使用回数',
      role_type: 'キャラクタータイプ',
      role_permissions: 'キャラクターの権限',
      system_role: 'システムキャラクター',
      custom_role: 'キャラクターのカスタマイズ'
    },
    department_manage: {
      Superior_department: '上級部門',
      Department_code: '部門コード',
      Department_name: '部門の名称',
      work_condition: '仕事の状態',
      work_status_on: '有効にする',
      work_status_off: '用度を止める',
      add_sub_department: 'サブ部門',
      add_brother_department: '同級部門を追加'
    },
    employee_manage: {
      status_on_the_job: '在職する',
      status_vacation: '休暇をとる',
      status_quit: '退職する',
      employee_code: '社員コード',
      employee_name: '従業員の名前',
      employee_role: '従業員役',
      subordinate_department: '所属部門',
      department_establishment_number: '部門編成番号',
      working_condition: '仕事の状態',
      normal_production_capacity: '正常な産能',
      budgetary_capacity: '予算の生産能力',
      id_number: '身分証番号',
      departmental_role: '部門役',
      department_staff: '部門従業員',
      department_head: '部門主管',
      phone_number: '電話番号',
      email: '郵便ポスト',
      user_code_same: '従業員コードの重複!'
    },
    device_manage: {
      working_condition: '仕事の状態',
      device_code: 'デバイスコード',
      device_name: 'デバイスの名称',
      equipment_brand: 'デバイスのブランド',
      producing_area: '設備の産地',
      Normal_capacity: '正常な産能',
      Maximum_capacity: '最大の産能',
      Budget_capacity: '予算の産能'
    },
    cost_type_manage: {
      cost_type: '費用の種類',
      cost_type_code: '料金タイプコード',
      cost_type_name: '費用の類名',
      parent_cost_type_code: "親料金タイプコード",
      parent_cost_type_name: "親費用の種類名",
      edit_parent_cost_type: '親費用のタイプを編集',
      edit_sub_cost_type: 'サブ料金のタイプを編集します'
    },
    operation_manage: {
      manual_operation: '手動工芸',
      automatic_process: '自動工芸',
      subsidiary_process: '付属工芸',
      outside_the_plan: '計画外工芸',
      procurement_process: '仕入工芸',
      outside_process: 'その他の工芸',
      internal_process: '内制工芸',
      project_process: 'プロジェクトプロセス',
      process_coding: '工芸コード',
      process_name: '工芸名',
      process_attributes: '工芸の属性',
      process_type: '工芸タイプ',
      conversion_process: '変換工芸',
      clamping_procedure: '加工工芸',
      report_way: '新聞のやり方',
      scheduling_attributes: '列の属性',
      cost_type: '費用の種類',
      default_preparation_time: '準備労働時',
      default_device_hours: '設備労働者',
      default_manpower_hours: '設備労働時',
      according_to_production_parameters: '生産パラメータを押す',
      ordinary: '普通',
      according_to_materiel_out_of_stock_code: '材料によって倉庫のバーコードを出す',
      allowable_excess_capacity: '超産能を許す',
      prohibition_excess_capacity: '超産能禁止',
      default_part_size: 'デフォルトの部品のサイズ',
      large_part_size: '大型部品',
      medium_part_size: '中型部品',
      small_part_size: '小型部品',
      default_transfer_time: '時間を転移する',
      default_preset_days: '予置日数',
      general_parts: '一般部品',
      core_parts: 'コア部分',
      material_retrieval_code: '材料出庫バーコード',
      bar_code_content:'バーコードの内容'
    },
    production_line_manage: {
      production_line_code: '生産ラインコード',
      production_line_name: '産線名'
    },
    shelf_manage: {
      shelf_code: '棚コード',
      shelf_name: '棚の名前',
      shelf_remark: '貨物棚の備考'
    },
    custom_manage: {
      title: '顧客管理',
      custom_code: '顧客コード',
      custom_name: 'お客様の略称',
      custom_full_name: 'お客様のフルネーム',
      custom_address: '住所',
      custom_area: 'エリア',
      custom_tel: '電話',
      custom_fax: 'ファックス',
      custom_mail: 'メールボックス',
    }
  },
  job_deployment: {
    operation_group: '作業組',
    administrative_department: '管理部門',
    operation_group_coding: '作業グループコード',
    name_of_operation_group: '作業組の名称',
    normal_production_capacity: '正常な産能',
    maximum_capacity: '最大の産能',
    association_process: '関連工芸',
    associated_production_line: '関連産線',
    associated_resources: '資源',
    resource_type: 'リソースのタイプ',
    resource_coding: 'リソースコード',
    resource_name: 'リソースの名前',
    staff: '従業員',
    equipment: '設備',
    shelves: '貨物棚',
    work_attributes: '仕事の属性',
    job_level: '作業レベル',
    partTime_productivity: 'アルバイト',
    fullTime: '全業',
    partTime_job: 'アルバイト',
    downtime: '停止機',
    apprentice: '学徒',
    primary: '初級',
    intermediate: '中級',
    senior: '高級',
    expert: '専門家',
    group_resources_delete_intercept: 'リソースを選択して、一部のリソースが工芸に割り当てられているので、削除できません！',
    craft_resources: '工芸資源'
  },
  custom_column: {
    integer: '整数',
    decimal: '小数点',
    text: 'テキスト（500字以内）',
    date: '日付',
    column_type: '列のタイプ',
    system_definition_column: 'システム定義',
    upper_shift: '上へ移動する',
    down_shift: '下へ移動する',
    employee_selection: '従業員の選択',
    device_selection: 'デバイスの選択',
    show_in_table: '表に見える',
    hide_in_table: '表に隠されている',
    img: '画像',
    column_width: '列の幅/ps',
    column_attribute: '列のプロパティ'
  },
  produce_order: {
    diagram: '略図',
    order_area: 'ワークショップ',
    processing_order: '制工書に',
    completion_order: '完成品',
    area_name: 'エリア名',
    can_report: '報告に参加する',
    can_schedule: '生産に参加する',
    add_sub_area: 'サブエリア',
    add_brother_area: '同級区域を追加',
    internal_part_only: '内だけの部品',
    internal_and_external_part: '内制と外発部品',
    lock_plan: '計画をロックする',
    not_locked: 'ロックしない',
    production_work_order: '生産工書',
    rate_of_progress: '進捗',
    delay_days: '遅延',
    copy_order_plan:'レプリカ生産工単主計画',
    copy_part_and_process:'部品と工程を複製する',
    copy_try_count:'デバッグ回数をコピー',
    target_try_count:'目標デバッグ回数',
    order_attribute:'シートのプロパティ',
    plan_attribute:'計画のプロパティ',
    product_attribute:'製品の特徴',
    customer_attribute:'顧客属性',
    calling_bom:'BOM 呼び出し',
    can_automatic: 'ひとりでに竣工する'
  },
  produce_part: {
    part_list_title: '部品リスト',
    part_select_all: '全選',
    part_un_select: '逆選択',
    part_attribute_default: 'すべて',
    part_attribute_part: '部品',
    part_attribute_sub: '付属部品',
    part_attribute_design: 'デザイン',
    part_attribute_assemble: '組み立てる',
    part_attribute_debug: '試算する',
    produce_part_split: '部品分割 ',
    part_split_error_message: '手動入力の数が総数を超えておりますので、再入力してください!',
    part_code_exist: '【%1】 存在します',
    part_delete_tips: 'この操作は選択した【%1】つのデータを削除します。続けますか?',
    part_copy_tips: 'この操作は選択した【%1】つのデータをコピーします。続けますか?',
    emergency_order: '非常さし込み',
    emergency_order_cancel: '差込みをキャンセルする',
    emergency_order_confirm: '緊急挿入書を実行しますか？',
    emergency_order_icon: '差し込み状'
  },
  produce_part_sub_list: {
    part_sub_list_title: '付属部品リスト',
    part_sub_list_column_orderIndex: 'シリアル番号',
    part_sub_list_column_file: 'AP工程技術ファイル',
    part_sub_list_choose_title: '选择附属零件列表',
    part_sub_list_selected: '选中列表'
  },
  produce_process: {
    process: '工程',
    process_list: '工程リスト',
    produce_process_split: '工程分割',
    please_input_required_split_num: '分割数を入力してください',
    process_split_num: '分割数',
    process_split_st: '仕事を分割する',
    part_card: "零件工艺卡",
    process_card: "工序工艺卡",
    same_crafts_card: "相同工艺卡",
    process_achievement: '実績の明細',
    process_state_un_start: "開始していません",
    process_state_processing: "加工中",
    process_state_completed: "完了しました",
    process_state_suspended: "加工を一時停止する",
    process_state_scrapped: "スクラップにする",
    process_state_purchase: "特採",
    process_state_received: "受信",
    process_state_part_received: "部分受信",
    process_state_un_completed: "未完工",
    appoint_time_tips: '開始時間は終了時間より長くすることはできません!'
  },
  process_library: {
    standard_order: '標準注文',
    template_no: "テンプレートコーディング",
    template_name: 'テンプレートの名前',
    template_attribute: '属性',
    template_attribute_craft: '工艺',
    import_part_process: '导入零件和工序',
    import_part: '导入零件',
    import_process: '导入工序',
    template_not_empty: "テンプレートのエンコードまたはテンプレート名は空にできません!"
  },
  approval_process: {
    Approval_type: '承認タイプ',
    Associated_data: '関連データ',
    Approval_add: '承認追加',
    Approval_modification: '審査の修正',
    Approval_deletion: '承認削除',
    Process_name: '流れの名称',
    Process_notes: 'プロセス注',
    Approval_process: '審査の流れ',
    Reporting_time: '報告の時間',
    Approval_intercept: '承認ブロック',
    Departmental_approval: '部門審査',
    superior_departments_approval: '上級部門の審査',
    custom_approval: 'カスタムフロー',
    All_approval: '承認すべて',
    All_data_will_be_approved: 'すべてのデータを審査する',
    Approval_by_order_type: '単型で審査する',
    Data_specifying_only_the_type_of_work_order: '単型のデータのみを指定します。',
    Approval_by_product_type: '製品のタイプで審査する',
    Data_that_specifies_only_product_types: '製品のタイプのデータのみを指定します。',
    please_select_approval_process: '審査の流れを選択してください'
  },
  approval_process_setting: {
    add_root_node: '承認ノードを追加する',
    auditor: '審査人'
  },
  report: {
    report_type: '新聞社のタイプ',
    report_receive: '受信する',
    report_start: '開始する',
    report_unfinished: '未完成',
    report_finished: '完成する',
    report_outside: '計画外',
    report_bar_code: 'ペーパーコード',
    report_single_person: 'シンポ',
    report_many_people: '多くの人が労働者に報告する',
    report_part_schedule: '部品の進捗',
    report_record:'労働記録',
    report_source:'勤務先を報告する',
    view_work_reporting_barcode:'新聞のバーコードを見る',
    appoint_resource_code: 'リソースを指定する',
    appoint_resource_name: 'リソースの名前を指定する',
    previous_process: '上道工程',
    next_process: '次の工程',
    operation_user: '実際の操作者',
    scan_barcode: 'バーコードをスキャンしますか',
    code_type:'バーコードの種類',
    qr_code:'バーコード',
    packet_number:'包装数',
    finished_quantity_cannot_be_less_than:'完成数量は0.01以下ではいけません。',
    the_start_quantity_cannot_be_greater_than_the_machinable_quantity:'開始数量は加工可能数より大きくしてはいけません。',
    batch_requisition_can_only_be_executed_under_the_same_processing_condition: '同じ加工状態では大量の新聞工を実行することができます',
    same_process_can_be_applied_for_batch_work: '同じ工芸では大量の新聞工を実行することができる',
    barcode_already_exists: 'バーコードは既に存在します',
    barcode_format_is_wrong: 'バーコードフォーマットが間違っています',
    are_you_sure_you_want_to_perform_operations_on_processes: '[$1]の工程に対して[$2]の操作を行うには、実行しますか？',
    selected_process_exists_already_started_process: 'プログラムを選択してから工程を開始しました！',
    tips_for_multiple_workers: '現在の任務は多くの人が完成します。「未完成」と報告し、個人の実際完成数量または完成比率を入力してください。',
    There_is_an_unacceptable_process_in_the_selected_process: '選択工程には受信できない工程がある！',
    No_finished_quantity_in_the_previous_process: '選択された工程の中に前工程があり、完成していない数量があります。受け入れられません。',
    There_is_no_starting_process_in_the_selected_process: '選択工程に未開始工程があります！',
    batch_operation_not_supported_finish: '現在の新聞は大量の操作を支持しないで、単独で新聞工を選んでください、もし量産のための工程のため、自動ロットで実行してください！',
    confirm_batch_report_finish: '現在の工程は量産として、同時に大量に操作するほかの工程がありますか？',
    Batch_reporting: '量紙工',
    Unpacking: '新聞を取り消す',
    Batch_start: 'ロット開始',
    Batch_completion: '大量に完成する',
    Unfinished_batch: 'ロットが完成していない',
    Batch_reception: 'ロット受信',
    report_info_setting: '情報設定',
    send_remark: '説明を引き継ぐ',
    receive_num: '受信数量',
    send_user: '送り主',
    message_please_select_resources_for_insert: 'を選択してください $1',
    mach_num: '加工数量',
    finish_num: '数量を完成する',
    mach_user: '加工人',
    mach_device: '加工設備',
    completion_rate: '労働時の完成率',
    confirm_batch_finish: '選択した工程に対して、そのロットからの工程を完成させ、実行しますか？',
    confirm_batch_un_finish: '選択した工程に対して、そのロットからの工程は未完成の操作を行い、ロット未完成の完成数と完成率は全て0として実行されますか？',
    process_is_not_existence: '工程は存在しません！',
    process_can_not_report: 'この工程では仕事をすることができません！',
    process_is_existence_to_select: '工程が存在し、この工程を選択',
    process_can_mach_num_is_zero: '選択工程の加工数が0になります！',
    previous_process_is_not_finish: '上の工程が完成していないので、現在の工程は開始できません！',
    has_previous_process_not_finish_process: '選択工程には、上道工程が完成していない工程があり、開始できません！',
    total_st: '総工時',
    finish_st: '仕上げ時間',
    process_can_not_add_report_detail: '現在の工程には新聞の数がありません、追加できません！',
    report_by_param_can_not_batch_report: '生産パラメーターによって加工の工程を報告して、大量に仕事を申し込むことができません！',
    report_by_material_out_barcode_can_not_batch_report: '材料の出庫バーコードによって作業の工程を報告して、量産の申し込みを実行することができません。',
    please_input_material_out_barcode: '材料出庫バーコードを入力してください!',
    finish_ratio: '完了率',
    current_finish_ratio: '今回の完成率',
    can_not_report_un_finish_return_to_finish: '全部の加工が終わりました。完工してください。',
    has_package_process_single_report: '包装の工程がありますが、包装業者を外しますか？',
    pack_process_list: '包装工程一覧',
    pack_single_report: '新聞の外注人',
    part_technical_file: '部品技術ファイル',
    process_technical_file: '工程技術ファイル',
    max_hour:'最小は1分を下回ってはいけません。最大は24時間を超えてはいけません。',
    report_deplane:'仕事が仕上がる',
    report_operate_a_computer:'開始',
    start_num:'開始数量',
    error_num:'不良数量',
    problem_classification:'問題の分類',
    problem_description:'問題の説明',
    please_input_start_num:'開始数量を入力してください。',
    report_material_code:'材料コード',
    mat_code_can_not_repeat:'バーコードは重複できません',
    mat_code_not_null:'バーコードは空ではいけません',
    process_finish:'工程の報告書は加工済みです。完成作業をお願いします。',
    batch_number:'バッチ番号',
    file_size_error:'ファイルサイズは5 Mを超えてはいけません。',
    finish_num_max_error:'最大完成数量は新聞の数量より多くてはいけません。',
    error_not_set_mrp:'先に工程のMRを設定してください',
    time_interval:'時間帯',
    anomaly_classification:'異常分類',
    abnormal_quality:'品質が異常である',
    abnormal_production_line:'作業場異常',
    abnormal_plan:'計画が異常である',
    mould_status:'カビの状態',
    finish_tips:'ヒント：もし任務が完成していないなら、完成した数量を入力してください。でないと、デフォルトは完成です。'
  },
  class_table_setting: {
    Employee_class_table: '従業員のクラス',
    Equipment_class_table: 'デバイス・クラス表',
    Holiday_setting: '休日の設定',
    Factory_holiday: '工場の休日',
    Employee_holiday: '社員の休日',
    set_month: '设定月份',
    class_table: '班表',
    detail: '明細',
    start_time: '開始時間',
    end_time: '終了時間',
    to_be_on_duty: '当番',
    rest: '休みをとる',
    interrupt: '中断する',
  },
  progress: {
    show_finished_parts: '完成部品',
    show_plan_time: '計画時間',
    show_actual_time: '実際の時間',
    show_standard_st: '標準労働時',
    show_actual_st: '実績',
    show_craft_name: '工程名',
    show_finish_day: '完了日数',
    out_of_parts: '部品の外発',
    combined_processing: '組み合わせ加工',
    process_synchronization: '工程同期',
    composite_relations_View: 'グループの関係',
    parts_filter: '部品の選別',
    add_sync: '同期を追加',
    sync_record: 'レコードを同期',
    start_date: '開始日',
    end_date: '終了日',
    outgoing_process: '外注工程',
    outgoing_num: '出荷数量',
    outgoing_date: '外注日',
    pre_parts: '前パーツ',
    pre_process: '前工程',
    rear_parts: 'バックアップ部品',
    postprocess: '後置工程',
    combination_type: 'グループのタイプ',
    process_combination: '工程の組み合わせ',
    part_assembly: '部品セット',
    message_The_current_process_exists_please_do_not_add_it_again: '現在の工程は存在しますので、重複しないでください。',
    message_Can_not_assemble_the_same_parts: '同じ部品を組み合わせることはできません。',
    message_The_number_of_adding_processes_on_this_side_has_reached_the_maximum: '本側添加工程数は最大値に達しました。',
    message_The_current_process_has_been_the_process_of_external_collaboration: '現在の工程はすでに外注工程です。',
    message_The_current_process_processing_status_does_not_allow_outsourcing: '現在の工程の加工状態は外注禁止です。',
    message_The_process_code_of_synchronous_process_must_be_the_same: '同期工程のプロセスコードは同じでなければなりません。',
    pack_type: 'パッケージタイプ',
    pack_type_same_order: '同工書で梱包する',
    pack_type_more_order: '積み荷証書を梱包する'
  },
  holiday_setting: {
    factory_holiday_setting: '工場区の休日の設定',
    monday: '月',
    tuesday: '火',
    wednesday: '水',
    thursday: '木',
    friday: '金',
    saturday: '土',
    sunday: '日',
    factory_holiday: '工場の休日',
    user_overtime: '従業員残業',
    user_holiday: '社員の休日',
    user_holiday_tip: '工場の休日を設定すると、従業員は残業します。'
  },
  offline_file_setting: {
    file_describe: 'ファイルの説明',
    storage_type: 'メモリタイプ',
    file_format: 'ファイルフォーマット',
    classify_name: 'カテゴリ名',
    respective_region: '所属区域',
    storage_type_local: 'ローカルファイル',
    storage_type_ftp: 'ftpファイル',
    storage_type_sftp: 'sftpファイル',
    respective_region_project: 'プロジェクトファイル',
    respective_region_order: 'ファイル',
    respective_region_part: '部品ファイル',
    respective_region_process: '工程ファイル',
    start_path: '開始パス',
    server_host: 'サーバIP',
    server_port: 'サーバポート',
    server_user_name: 'ユーザーアカウント',
    server_user_password: 'パスワード',
    label_width: '160px',
    file_path: 'ファイルパス',
    add_fuzzy_path: 'あいまいなパスを追加',
    add_fuzzy_path_confirm: 'あいまいなパスを追加した後に、ファイルのアップロードをサポートしないで、手動操作を必要とします。',
    error_add_path: 'パスを設定してください',
    file_classify: "ファイル分類",
    classify_setting: 'ファイル分類設定'
  },
  standard_procedure_setting: {
    title: 'タイトル',
    width: '幅',
    table: 'テーブル',
    table_setting: 'テーブルの設定',
    production_params: '生産パラメータ',
    add_plan_row: '計画パラメータを追加',
    add_real_row: '実際のパラメータを追加',
    device_operating_params: 'デバイス運転パラメータ',
    show_line_number: '行番号を表示',
    show_row_number: '行の数を表示',
    comparison_table: '比較表',
    comparison_table_setting: '表に対する設定',
    comparison_mode: 'マッチング方式',
    comparison_mode_1: '横比率',
    comparison_mode_2: '縦割り',
    reference_column: '列名を参照',
    each_generation_reference_column: 'ペア毎に参照列を生成',
    comparison_column_number: '列の数を比べる',
    comparison_column: '列の名前',
    form: 'フォーム',
    form_setting: 'フォームの設定',
    add_row: '行を追加',
    delete_row: '行を削除',
    add_column: '列を追加',
    column_type: '列の種類',
    column_number: '列の数',
    column_format: '列の書式',
    column_name: '列の名前',
    row_span: '行数を越える',
    column_span: '列を越える',
    show_text: 'テキストを表示',
    input_box: '入力ボックス',
    data_type: 'データの種類',
    double_reserved_points_prepend: '保留',
    double_reserved_points_append: 'ビット小数点',
    year: '年',
    month: '月',
    day: '日',
    hour: '時刻',
    minute: 'ポイント',
    second: '秒',
    show_code: 'エンコーディングを表示',
    show_name: '名前を表示',
    show_code_and_name: 'エンコーディングと名前を表示',
    current_row_can_not_add_column: '現在の行は列を追加できません。',
    filed_column: '列フィールド',
  },
  produce_plan: {
    plan_versions: '計画版',
    import_title: '導入',
    download_title: '導出',
    upload_title: '導入計画',
    chooseFile: 'ファイルを選択',
    uploadTip: 'xlsx/xlsファイルのみアップロードできます。しかも50 Mを超えません。!',
    plan_of_day_title: 'グループ日計画',
    appoint_day_plan: "日取りを立てる",
    cancel_day_plan: "取消日计划",
    produce_day_plan: "日計画",
    non_existent: "存在しません！",
    load_st: "負荷時間",
    modal_cloud_setting: "ダイ雲設定",
    middle_schedule: 'スケジュール',
    part_middle_schedule: '部品中スケジュール',
    small_schedule: 'スケジュール',
    waiting_area: '受信待ちエリア',
    processing_area: '加工待ち区域',
    completion_area: '竣工区',
    employee_performance: '従業員のパフォーマンス',
    produce_plan_load: '生産負荷',
    stagnation_time: '呆滞时间',
    receive_time: '接收时间',
    start_time: '开始时间',
    end_time: '结束时间'
  },
  produce_plan_load: {
    produce_plan_load_st: '負荷時間:',
    capacity_tip: '標準生産能力',
    max_capacity_tip: '最大の生産能力',
  },
  quality_manage: {
    execute_state: '処理状態',
    operation: '操作',
    po_num: 'PO番号',
    delivery_note_num: '送り状番号',
    remedy_user: '補完者',
    duty_process: '責任工程',
    find_process: '工程を発見する',
    remedy_time: '救済日付',
    wait_for_initiation: '発起を待つ',
    remedies_will_signed: '救済措置はくじに当たる',
    remedial_measures_were_not_signed: '救済措置は未可決となった。',
    quality_tracing: '品質の遡及',
    quality_traceability_signature_ing: '品質遡及契約中',
    finished_process: '処理済み',
    cancelled: 'キャンセルしました',
    jointly_sign: '署名する',
    remedial_measures: '救済措置',
    person_liable: '責任者',
    find_people: '人を発見する',
    quantity_of_rework: '再工数',
    error_classification: 'エラーの分類',
    error_reason: 'エラーの原因',
    specific_quantity: '特注数量',
    scrap_quantity: '廃棄数量',
    common_signer_settings: '常用契約者設定',
    initiating_countersign: '会札を出す',
    unsigned_execution: '署名なしで実行',
    counter_signer: '契約者',
    countersignature_status: '署名状態',
    countersigned_endorsement: '注釈にサインする',
    countersignature_time: '調印時間',
    abandonment: '髪を打ち消す',
    staff_coding: '従業員コード',
    employee_name: '従業員の名前',
    remedies_will_be_signed: '救済措置は調印する',
    quality_traceability_signature: '品質遡及契約',
    selection_of_signers: '契約者を選ぶ',
    to: 'を選択します',
    cancel_countersign: '会則を取り消す',
    adopt: '通過する',
    not_pass: '不合格',
    no_countersigned: '未契約',
    label_width: '60px',
    loss_label_width: '87px',
    label_value_margin: '0px',
    please_select_responsible_process: '責任工程を選択してください。',
    please_select_the_person_responsible: '責任者を選んでください',
    please_select_the_discovery_process: '発見工程を選択してください。',
    please_select_the_discoverer: '発見者を選んでください',
    please_enter_the_quantity_of_rework: 'やり直しの数を入力してください。',
    please_select_the_error_classification: 'エラーの分類を選択してください。',
    please_enter_the_special_quantity: '特採数量を入力してください。',
    please_enter_the_amount_of_scrapped: '廃棄量を入力してください。',
    please_choose_the_way_to_deal_with_it: '処理方法を選択してください。',
    please_select_the_data_that_needs_to_be_signed: '署名を実行するデータを選択してください。',
    successful_operation: '操作が成功しました',
    penalty_charge: '罰金を取る',
    amount_of_penalty: '処罰金額',
    loss_of_working_hours: '労働時間を失う(H)',
    loss_due_date: '損失納期',
    loss_of_material_cost: '損失材料コスト',
    loss_of_manufacturing_costs: '損失製造コスト',
    penalty_notes: '処罰の説明',
    will_sign_back_history: '歴史に戻ります',
    responsibility_judgement: '責任判定',
    punished_person: '処罰される人',
    please_choose_the_person_to_be_punished: '処罰される方を選んでください。',
    quality_traceability_will_sign_back_records: '品質追跡は記録に戻ります。',
    will_sign_the_withdrawal_record: '署名して記録を撤回する',
    operator_coding: 'オペレーターコード',
    operator_name: '作業者名',
    operation_time: '操作時間',
    details_of_withdrawal_records: '署名して記録の明細を撤回します。',
    coding_of_responsible_person: '責任者コード',
    name_of_responsible_person: '責任者名',
    responsible_human_type: '責任者タイプ',
    responsibility_ratio: '責任の比率',
    supplier: 'ベンダー',
    factory_staff: '当工場の従業員',
    supplier_staff: 'サプライヤー従業員',
    general_factory_staff: '工場長',
    adding_responsible_persons: '責任者を追加',
    yes: 'はい',
    no: 'いいえ',
    the_selected_signer_is_not_identical_with_the_actual_signer: '選ばれた立会人は実際の立会人と一致しないので、立会署名はできません。',
    display_completed_items: '完了項目を表示',
    delete_successfully: '削除成功！',
    canceled_deletion: '削除しました',
    this_action_will_delete_the_selected: 'この操作は選択したものを削除します。',
    an_exception_list_do_you_want_to_continue: 'つ異常票,は継続しますか？',
    only_canceled_data_can_be_deleted_the_current_selected_item_contains_other_states: 'キャンセルされたデータのみ削除できます。現在の選択項目には他の状態が含まれています。',
    rework: '帰工する',
    degrade: '特別採掘',
    scrap: 'スクラップにする',
    you_signed_up_and_can_participate_again: "あなたはすでに契約済みです。もう二度と参加できません。",
    personnel: "人員",
    number: "数",
    actual_technology_parameter: "プロセスパラメータ",
    indirect_material_cost: "間接材料コスト",
    problem_classification:'問題の分類',
    problem_description:'問題の説明'
  },
  project_master_plan: {
    node_setting: '計画ノード設定',
    node_code: 'ノードコード',
    node_name: 'ノード名',
    node_type: 'ノードのタイプ',
    production_node: '生産ノード',
    purchase_node: '購買ノード',
    ability: '能力H/D',
    max_ability: '最大能力H/D',
    node_cost_type: '計画ノード-料金の種類',
    cost_type_part_classify: '費用の種類-部品の分類',
    by_month: '月ごとに',
    by_week: '週ごとに',
    by_day: '日割りで',
    by_hours: '按小时',
    plan: '計画',
    estimated_st: '工数を見積もる',
    related_node: '関連ノード',
    relation_type: '関連のタイプ',
    postposition_days: '後の日数',
    plan_time: '予定日',
    plan_start_time: '計画開始日',
    plan_end_time: '計画完了日',
    actual_st: '実働時間',
    capacity_ratio: '生産能力の比率',
    delivery_date: '納品日',
    delivery_date_change_count: '変更回数',
    delay_days: '日数を延ばす',
    unit_price: '単価',
    force_time: '強制時間帯',
    yes: 'はい、',
    no: 'いいえ、',
    plan_node_select: 'プロジェクトノードを選択',
    relation_plan_start_time: '関連計画開始日',
    relation_plan_end_time: '関連計画の完成日',
    move_down: '下に移動',
    move_up: '上へ移動',
    when_change_node_code: 'ノードコードを修正していると、ノードの加工進捗が再計算されます。この操作は比較的に時間がかかりますが、操作を実行しますか？',
    master_plan_number: '計画ノード数',
    import_other_plan_node: '他の生産工票から導入する',
    node_is_used_can_not_change_type: 'ノード使用中、ノードタイプは変更できません!'
  },
  project_master_plan_template_setting: {
    master_plan_template: 'プロジェクトテンプレート',
    template: 'テンプレート',
    template_name: 'テンプレート名',
    plan_node_list: '計画ノード一覧',
    import: 'インポート',
    import_template: 'テンプレートをインポート',
    message_please_select_template_to_import: 'インポートするテンプレートを選択してください。',
    confirm_import_template: 'テンプレート[%1]のプロジェクトノードをインポートしますか？',
  },
  cas_login: {
    cas_login_message_authentication_failure: '認証に失敗しました!',
    cas_login_message_employee_not_found: '認証に失敗しました。対応するユーザが見つかりませんでした!',
    cas_login_message_factory_not_found: '認証に失敗しました。対応工場が見つかりませんでした!'
  },
  project_manage: {
    add_project: '新規プロジェクト',
    modify_project: 'アイテムを編集',
    add_sub_project: '新規サブプロジェクト',
    save_and_add_subprojects: 'サブアイテムを保存して追加します',
    save_and_add_peer_projects: '同じレベルの項目を保存して追加します',
    edit_project: '編集',
    delete_project: '削除',
    project_plan: 'プロジェクト計画',
    add_produce_order: '生産工表を追加する',
    add_project_order: 'プロジェクトリストを追加する',
    parent_project_code: '上位項目コード',
    project_classify: 'アイテムの種類',
    project_code: 'プロジェクトコード',
    project_name: 'プロジェクト名',
    project_order_code: 'プロジェクトシート',
    custom: '客户',
    custom_code: '顧客コード',
    custom_name: '顧客名',
    end_custom: 'エンドクライアント',
    end_custom_code: 'エンドクライアントコード',
    end_custom_area: 'エンド顧客エリア',
    project_leader: '責任者',
    input_time: '入力時間',
    delivery_time: 'プロジェクト納期',
    project_ratio: '進捗',
    project_amount: 'プロジェクトの金額',
    budget_amount: '予算額',
    receivable_amount: '未収金額',
    unpaid_amount: '受取金額',
    paid_amount: '既払い金',
    budget_manage: '予算管理'
  },
  download: {
    offLineTools: {
      title: 'MES線下の補助工具',
      describe: 'リードデータの導入とファイル管理において、オフラインファイルのアップロード、オープン（ftp、sftp、ローカルファイルのサポート）を行います。自動列またはファイル管理モジュールを使用する場合は、このソフトウェアをダウンロードして共同で使用する必要があります。ソフトウェアはパレットプログラムで、起動したら自動的にシステムトレイに動作します。Windows 7、windows 8、windows 10をサポートします。リードデータの導入とファイル管理において、オフラインファイルのアップロード、オープン（ftp、sftp、ローカルファイルのサポート）を行います。自動列またはファイル管理モジュールを使用する場合は、このソフトウェアをダウンロードして共同で使用する必要があります。ソフトウェアはパレットプログラムで、起動したら自動的にシステムトレイに動作します。Windows 7、windows 8、windows 10をサポートします',
      language: '言語',
      file_name: 'ファイル名',
      size: 'サイズ',
      download: 'ダウンロード'
    }
  },
  forms: {
    monitoring_platform: 'モニタプラットフォーム',
    details_of_staff_daily: '従業員日報明細',
    process_in_machining: '加工中の工程',
    department: '部署',
    export_config: 'エクスポートの設定',
    export_column_selector: 'エクスポート列を選択',
    process_status: '工程の状態',
    mach_status: '加工状態',
    performance_total_amount: '実績金額',
    standard_total_amount: '標準金額',
    performance_summary: '実績まとめレポート',
    actual_amount: '実績金額',
    standard_amount: '標準金額',
    abnormal_working_hours: '異常工数',
    abnormal_cost: '異常コスト',
    unplanned_hours: '計画外労働時間',
    unplanned_amount: '計画外金額',
    rate_of_progress: '進捗率',
    report_quality_department: "品質レポート",
    workshop_report: '作業場レポート',
    quality_report: "品質レポート",
    processing_mode: "処理モード",
    quality_state: "品質状態",
    number_errors: "エラー件数",
    discovery_time: "時間を見つける",
    component_type: "部品タイプ",
    parts_and_processes: "部品&工程",
    discard_time: "廃車",
    rework_time: "アルバイトに戻る",
    standard_preparation_time: "標準準備工数",
    standard_manpower_hours: "標準的な労働時間",
    standard_device_hours: "標準設備工数",
    performance_preparation_time: "実績準備工数",
    performance_manpower_hours: "実績マンパワー",
    performance_device_hours: "設備工数を実績する",
    outside_and_purchase_process: '外部協和調達',
    details_of_cost_report: '実績明細表',
    indirect_code: '間接番号',
    indirect_date: 'かんせつ時間',
    outside_the_plan: '計画外',
    inside_the_plan: '計画内',
    cost_report: '原価計算書',
    submit_cost_details: '原価勘定表',
    plan_amount: '計画額',
    abnormal_amount: '異常金額',
    cost_type_manage_children: 'サブ料金の種類',
    planned_cost: '計画コスト',
    actual_cost: '実費',
    total_planned_hours: '計画工員時',
    total_actual_hours: 'すべての実際労働時間',
    total_abnormal_hours: 'すべての異常工数',
    total_unplanned_hours: 'すべての計画工数',
    total_unplanned_cost: '計画外原価',
    processing_cost: '加工コスト',
    outside_process_cost: '外注コスト',
    procurement_cost: '仕入れコスト',
    quality_analysis_report:"品質分析レポート",
    error_type:"エラーの種類",
    wrong_number:"エラーの数",
    responsible_team:"責任班",
    responsible_supplier:"責任サプライヤー",
    statistical_histogram:"統計ヒストグラム",
    quality_management_report:"品質管理レポート",
    part_and_process_schedule:'部品工程スケジュール表',
    details_of_device_daily: 'デバイス毎日報告する',
    alert_of_staff_abnormal:'従業員報告異常警告',
    processing_timeout:'加工タイムアウト',
    part_warehouse_status_analysis:'部品の進捗状況が悪い',
    finish_num:'完成数',
    inventory_num:'入庫数量',
    not_inventory_num:'未入庫数',
    inventory_type:'入庫タイプ',
    part_put_in_storage:'部品入庫',
    order_put_in_storage:'注文入庫',
    total_weight:'総重量',
    employee_salary_detail: '従業員給与明細',
    valuation_weight:"見積もり高",
    valuation_weight_total:"評価総量",
    process_money:"工程総価格",
    valuation_method:"価格の計算方法",
    fixed_salary:"定額賃金",
    overtime_money:"時間外賃金",
    overtime_hours:"残業時間",
    total_wages:"賃金総額",
    share_cost_details:"コスト配分レポート",
  },
  recovery: {
    title: 'データを削除して復元します',
    recovery: '元に戻す',
    delete_user: '人を削除',
    delete_time: '削除時間',
    recovery_order: '選択した【%1】データを復元しますか？',
    recovery_mach: '選択した【%1】レポートを復元しますか？復旧後は、手動で工数、工数を調整する必要があります。'
  },
  customer_form: {}
};



// WEBPACK FOOTER //
// ./src/common/lang/ja.js